/**
 * This is a singleton to ensure we only instantiate Classic Stripe once.
 */

import { loadStripe, Stripe } from '@stripe/stripe-js';

let classicStripePromise: Promise<Stripe | null>;

export const getClassicStripe = (): Promise<Stripe | null> => {
	if (!classicStripePromise) {
		classicStripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_TOKEN as string);
	}
	return classicStripePromise;
};

// for backwards compatibility
export const getStripe = getClassicStripe;

/**
 * This is a singleton to ensure we only instantiate Sleep Stripe once.
 */

let sleepStripePromise: Promise<Stripe | null>;

export const getSleepStripe = (): Promise<Stripe | null> => {
	if (!sleepStripePromise) {
		sleepStripePromise = loadStripe(process.env.NEXT_PUBLIC_SLEEP_STRIPE_TOKEN as string);
	}
	return sleepStripePromise;
};
